import { styled } from "styled-components";

export const Bar = styled.div`
  width: 100%;
  height: 100%;
  border-radius: 8px;
  background-color: rgba(45, 45, 55, 1);
  color: white;
  display: flex;
  align-items: center;
`;

export const Input = styled.input`
  background-color: transparent;
  color: white;
  opacity: 1;
  width: 100%;
  border: none;
  outline: none;
  padding-left: 0.5rem;
`;

export const LoupeIconContainer = styled.div`
  width: 20px;
  height: 17.5px;
  padding-left: 0.5rem;
`;

export const LoupeIconImg = styled.img`
  width: 100%;
  height: 100%;
  display: flex;
  align-self: center;
  justify-self: center;
`;